module.exports = __webpack_public_path__ + "static/img/5.46e3cf6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/challenge/5.png
// module id = 95Z+
// module chunks = 1